import http from "./httpService";
import config from "../config.json";


export function loginServices(data){
    return http.post(config.apiUrl+"/roverapi/v1/login", data);
}
export function sendEnquiry(data){
    return http.post(config.apiUrl+"/roverapi/v1/sendEnquiry", data);
}